
import React from "react";
import { Link } from "react-router-dom";
import { ChevronDown, ArrowRight } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { popularLocations, otherLocations, resourceItems, companyItems } from "./navData";

interface NavLinksProps {
  locationDropdownOpen: boolean;
  setLocationDropdownOpen: (open: boolean) => void;
  resourcesDropdownOpen: boolean;
  setResourcesDropdownOpen: (open: boolean) => void;
}

export default function NavLinks({
  locationDropdownOpen,
  setLocationDropdownOpen,
  resourcesDropdownOpen,
  setResourcesDropdownOpen
}: NavLinksProps) {
  return <div className="flex items-center space-x-8">
      {/* Nursing Homes Dropdown */}
      <DropdownMenu open={locationDropdownOpen} onOpenChange={setLocationDropdownOpen} modal={false}>
        <DropdownMenuTrigger asChild>
          <button className="group flex items-center space-x-1.5 text-gray-700 hover:text-grandpal-green-dark transition-colors">
            <span className="font-medium">Nursing Homes</span>
            <ChevronDown className="h-4 w-4 transition-transform duration-300 group-hover:text-grandpal-green-dark" style={{
            transform: locationDropdownOpen ? 'rotate(180deg)' : 'rotate(0)'
          }} />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-screen p-0 bg-white shadow-md border-none rounded-none border-t border-gray-100 mt-3.5 z-50" align="start" sideOffset={0}>
          <div className="container py-8 animate-fade-in">
            <h3 className="text-grandpal-green-dark mb-6 font-bold text-xl">Popular Nursing Home Locations</h3>
            <div className="grid grid-cols-4 gap-x-16 gap-y-4">
              {popularLocations.map(location => <Link key={location.title} to={location.path} className="text-gray-700 hover:text-grandpal-green-dark transition-colors text-base">
                  {location.title}
                </Link>)}
              {otherLocations.map(location => <Link key={location.title} to={location.path} className="text-gray-700 hover:text-grandpal-green-dark transition-colors text-base">
                  {location.title}
                </Link>)}
            </div>
            <div className="mt-6">
              <Link to="/nursing-homes" className="flex items-center text-grandpal-green-dark font-medium hover:text-grandpal-green-darkHover text-base group">
                View all Nursing Homes
                <ArrowRight className="ml-1.5 h-4 w-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </div>
          </div>
        </DropdownMenuContent>
      </DropdownMenu>

      {/* Resources Dropdown */}
      <DropdownMenu open={resourcesDropdownOpen} onOpenChange={setResourcesDropdownOpen} modal={false}>
        <DropdownMenuTrigger asChild>
          <button className="group flex items-center space-x-1.5 text-gray-700 hover:text-grandpal-green-dark transition-colors">
            <span className="font-medium">Resources</span>
            <ChevronDown className="h-4 w-4 transition-transform duration-300 group-hover:text-grandpal-green-dark" style={{
            transform: resourcesDropdownOpen ? 'rotate(180deg)' : 'rotate(0)'
          }} />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-screen p-0 bg-white shadow-md border-none rounded-none border-t border-gray-100 mt-3.5 z-50" align="start" sideOffset={0}>
          <div className="container mx-auto py-10 animate-fade-in">
            <div className="grid grid-cols-2 gap-12">
              <div>
                <h3 className="text-grandpal-green-dark mb-6 text-xl font-bold font-lora">Resources</h3>
                <ul className="flex flex-col gap-2">
                  {resourceItems.map(item => <li key={item.title}>
                      <Link to={item.path} className="flex items-start gap-4 hover:bg-grandpal-green-light p-3 rounded-md transition-all group">
                        <span className="flex-shrink-0 h-12 w-12 flex items-center justify-center rounded-md bg-[#e5f4ee] group-hover:bg-grandpal-green-lighter transition-colors">
                          <span className="text-grandpal-green-dark text-2xl">{item.icon}</span>
                        </span>
                        <div>
                          <div className="font-medium text-gray-800 text-lg mb-0.5">{item.title}</div>
                          <p className="text-sm text-gray-500">{item.description}</p>
                        </div>
                      </Link>
                    </li>)}
                </ul>
              </div>
              <div>
                <h3 className="text-grandpal-green-dark mb-6 text-xl font-bold font-lora">Company</h3>
                <ul className="flex flex-col gap-2">
                  {companyItems.map(item => <li key={item.title}>
                      <Link to={item.path} className="flex items-start gap-4 hover:bg-grandpal-green-light p-3 rounded-md transition-all group">
                        <span className="flex-shrink-0 h-12 w-12 flex items-center justify-center rounded-md bg-[#e5f4ee] group-hover:bg-grandpal-green-lighter transition-colors">
                          <span className="text-grandpal-green-dark text-2xl">{item.icon}</span>
                        </span>
                        <div>
                          <div className="font-medium text-gray-800 text-lg mb-0.5">{item.title}</div>
                          <p className="text-sm text-gray-500">{item.description}</p>
                        </div>
                      </Link>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </DropdownMenuContent>
      </DropdownMenu>

      {/* Guide Link - Updated to Guides */}
      <Link to="/guides" className="text-gray-700 hover:text-grandpal-green-dark font-medium transition-colors">
        Guides
      </Link>
    </div>;
}
